import { useCities } from '~/store/cites/cities.store'
import { useMainStore } from '~/store/main/main.store'

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (import.meta.server) {
    if (to.params?.city?.includes('address')) return navigateTo(to.fullPath?.replace(/.*\/address\//, '/personal/address/'), { redirectCode: 301 })
    if (to.params?.city?.[0] === 'undefined') return navigateTo(to.fullPath?.replace('undefined', 'msk'), { redirectCode: 301 })
    const store = useCities()
    const res = await store.nuxtServerInit(to)
    if (res) {
      throw createError({
        statusCode: res.statusCode === 410 ? 410 : 404,
        fatal: true,
        message: 'not found',
      })
    }
    const redirectObj = store.getRedirectObj

    if (redirectObj && redirectObj.url !== to.fullPath) {
      const redirectUrl = new URL(redirectObj.url, 'http://localhost')
      return navigateTo(redirectUrl.pathname + redirectUrl.search, {
        redirectCode: redirectObj.code || undefined,
      })
    }
  }
  if (import.meta.client) {
    const mainStore = useMainStore()
    if (
      !(
        /providers-provider.*/i.test(to.name)
        || (/city-reviews.*/i.test(to.name)
          && /\/providers\//i.test(to.path)
          && to.name !== 'city-providers-provider-tariffs-id')
      )
    ) {
      const nuxtApp = useNuxtApp()
      const diNotProviderCookie = useCookie('diNotProvider')
      nuxtApp.hook('page:finish', () => {
        mainStore.$patch({ diProvider: false })
        diNotProviderCookie.value = true
      })
    }
  }
})
